export class CheckoutWidgetPlaceHolderConfigParam {
	enableShipping: boolean;
	enableMembershipPointsConversion: boolean;
	enableCashVoucher: boolean;
	enablePgw: boolean;
}

export class ProductListDisplayWidgetPlaceHolderConfigParams {
  productDetailsLayout: string;
  priceColor: string;
}

export class ProductSliderWidgetPlaceHolderConfigParams {
	categoryCode: string;
	productListDisplayLayout: string;
	productDetailsLayout: string;
}

export class MyInvoiceWidgetPlaceHolderConfigParams {
	myInvoiceDetailLayout: string;
}

export class MyInvoiceDetailWidgetPlaceHolderConfigParams {
	myInvoiceItemDetailLayout: string;
  myInvoicePaymentLayout: string;
  myInvoiceRequestRefundLayout: string;
  maxNoDays: number;
  enableRefund: boolean;
}

export class MyInvoicePaymentWidgetPlaceHolderConfigParams {
	myInvoiceLayout: string;
  myInvoiceDetailLayout: string;
  myInvoiceItemDetailLayout: string;
}

/**
 * @deprecated
 * CardModel will be replaced by post
 */
export class CPCommerceCardModel {
	title: string;
	subtitle?: string;
	img_url: string;
	content: string;
	btnName?: string;
	btnNavigationUrl?: string;
}

/**
 * @deprecated
 * CardLayoutWidgetPlaceHolderConfigParamsOld will be replaced by CardLayoutWidgetPlaceHolderConfigParams
 */
export class CardLayoutWidgetPlaceHolderConfigParamsOld {
	title: string;
  cards: CPCommerceCardModel[];
}

export class CardLayoutWidgetPlaceHolderConfigParams {
  title: string;
	post_guids: string[];
}

export class StaticPageWidgetConfigParams {
	guid: string;
}

export class ShippingAddressWidgetConfigParams {
	editRoute: string;
	addRoute: string;
}

export class ShippingAddressAddWidgetConfigParams {
	onSaveRoute: string
}

export class ShippingAddressDetailsWidgetConfigParams {
	onSaveRoute: string
}

export class NewsListWidgetConfigParams {
	newsDetailsRoute: string;
}

export class ShoppingCartWidgetConfigParams {
	checkoutRoute: string;
	productCategoryListingRoute: string;
}

export class VoucherListWidgetConfigParams {
	voucherDetailsRoute: string;
}

export class CategoryGroupTilesWidgetPlaceHolderConfigParams {
	title: string;
	labelListGuid: string;
	labelHdrsAndLayoutUrls: Array<{ labelHdrGuid: string, destinationUrl: string }>;
	destination_url: string;
}

export class ProductDetailsWidgetConfigParams {
	checkoutRoute: string;
}

